<template>
    <div class="loginheader">
        <a href="/"> <img src="../../assets/images/logo.png" alt=""></a>
        <div class="line"></div>
        <span>欢迎登录</span>
    </div>
</template>
<script>
export default {}
</script>
<style scoped>
.loginheader {
    padding: 12px 0;
    padding-left: 12%;
    display: flex;
    align-items: center;
}

.line {
    float: left;
    width: 1px;
    height: 31px;
    background: #999;
    margin: 0 18px;
}

.loginheader span {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999;
}
</style>